module.exports = __webpack_public_path__ + "img/MassBalance.1a9a2965.svg";